import axiosInstance from "utils/axiosInstance";
import { appUrls } from "helpers/Urls";

const editPatientProfile = async ({ id, data }) => {
    const response = await axiosInstance.put(appUrls.editPatient(id), data);
  return response;
};
export default editPatientProfile;

